module.exports = __webpack_public_path__ + "img/chara_line_7.e98aa350.png";